import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTextField,{staticClass:"searchInput",attrs:{"placeholder":_vm.compPlaceholder,"autofocus":_vm.autofocus,"prepend-inner-icon":_vm.icon,"rbt-target":"searchInput","clearable":"","hide-details":""},model:{value:(_vm.beforeUpdateSnippet),callback:function ($$v) {_vm.beforeUpdateSnippet=$$v},expression:"beforeUpdateSnippet"}})}
var staticRenderFns = []

export { render, staticRenderFns }